import { Stack } from "@mui/material";
import { PopperWrapper } from "Common/Components/Wrappers/PopperWrapper";

interface IHeaderPopup {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleClose: (event: Event | React.SyntheticEvent) => void;
  children?: React.ReactNode;
  minWidth?: number;
}
export const HeaderPopup: React.FC<IHeaderPopup> = (props) => {
  const { anchorEl, open, handleClose, children, minWidth } = props;
  return (
    <PopperWrapper
      open={open}
      placement={"bottom-end"}
      anchorEl={anchorEl}
      onClose={handleClose}
      paperProps={{
        sx(theme) {
          return {
            width: "100%",
            minWidth: minWidth ?? 285,
            maxWidth: 420,
            padding: theme.spacing(0),

            [theme.breakpoints.down("sm")]: {
              maxWidth: "100%",
              width: "100vw",
            },
          };
        },
      }}
    >
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        sx={{ height: "100%" }}
      >
        {children}
      </Stack>
    </PopperWrapper>
  );
};
